import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiUser, FiPhone, FiLoader } from 'react-icons/fi';
import { apiCall } from '../api/client';

const RegistrationForm = ({ token, onSuccess }) => {
  const [formData, setFormData] = useState({
    participant_name: '',
    mobile_number: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.participant_name.trim()) {
      setError('يرجى إدخال اسم المشارك');
      return;
    }

    const mobileRegex = /^05\d{8}$/;
    if (!mobileRegex.test(formData.mobile_number)) {
      setError('يجب إدخال رقم جوال صحيح');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // إضافة limit=10000 للتحقق من التكرار ضمن جميع السجلات
      const response = await apiCall('/read/participants?limit=10000', 'GET', null, token);
      const existingParticipants = response.data || [];
      
      const isDuplicate = existingParticipants.some(
        p => p.mobile_number === formData.mobile_number
      );

      if (isDuplicate) {
        setError('تم التسجيل سابقاً');
        setLoading(false);
        return;
      }

      const today = new Date().toISOString().split('T')[0];
      const payload = {
        participant_name: formData.participant_name,
        mobile_number: formData.mobile_number,
        registration_date: today,
        attendance_status: 'لم يحضر'
      };

      await apiCall('/create/participants', 'POST', payload, token);
      
      if (onSuccess) onSuccess();
      
    } catch (err) {
      setError('حدث خطأ أثناء الإرسال، يرجى المحاولة مرة أخرى');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 10) {
      setFormData({ ...formData, mobile_number: value });
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-white p-8 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-bold text-slate-700 mb-2 mr-1">الاسم</label>
          <div className="relative">
            <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none text-slate-400">
              <SafeIcon icon={FiUser} />
            </div>
            <input
              type="text"
              required
              value={formData.participant_name}
              onChange={(e) => setFormData({ ...formData, participant_name: e.target.value })}
              className="w-full pl-4 pr-11 py-4 border border-slate-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#9f8574] transition-all bg-slate-50 focus:bg-white text-lg font-medium"
              placeholder="اكتب اسمك هنا..."
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-bold text-slate-700 mb-2 mr-1">رقم الجوال</label>
          <div className="relative">
            <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none text-slate-400">
              <SafeIcon icon={FiPhone} />
            </div>
            <input
              type="tel"
              required
              value={formData.mobile_number}
              onChange={handleMobileChange}
              className="w-full pl-4 pr-11 py-4 border border-slate-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#9f8574] transition-all bg-slate-50 focus:bg-white text-lg font-medium text-right"
              placeholder="05XXXXXXXX"
              dir="ltr"
            />
          </div>
        </div>

        {error && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            className="p-4 bg-red-50 text-red-600 rounded-xl text-sm font-bold border border-red-100 text-center"
          >
            {error}
          </motion.div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{ backgroundColor: '#9f8574' }}
          className="w-full py-4 hover:opacity-90 text-white rounded-2xl font-bold text-xl transition-all shadow-lg shadow-slate-200 flex items-center justify-center gap-3 disabled:opacity-70 active:scale-95"
        >
          {loading ? (
            <SafeIcon icon={FiLoader} className="animate-spin text-2xl" />
          ) : (
            <span>تأكيد</span>
          )}
        </button>
      </form>
    </motion.div>
  );
};

export default RegistrationForm;